const _ = "slider_W8dPx", o = "slider__controls_0Rx2T", r = "slider__control_b76Bf", l = "slider__control__prev_9jaAB", s = "slider__control__next_tmyS4", t = {
  slider: _,
  slider__controls: o,
  slider__control: r,
  slider__control__prev: l,
  slider__control__next: s
};
export {
  t as default,
  _ as slider,
  r as slider__control,
  s as slider__control__next,
  l as slider__control__prev,
  o as slider__controls
};
//# sourceMappingURL=smallSlider.module.scss.js.map
